<!-- EU: the app is released, so show app-store links + QR (same as the leasecoSuccess page). The SMS "text me the app" flow is non-EU only. -->
<ng-container *ngIf="isEu">
  <p>{{ "Once you’re verified, we’ll send you a confirmation email. You can use your ChargePoint account to charge at paid public stations." |T }}</p>
  <p>{{ "To find stations and manage your account, download the ChargePoint mobile app." |T }}</p>
  <div class="phone-container">
    <img class="phone-image" src="/assets/images/mobile_screenshot.png" alt="" />
  </div>
  <div class="pt-2 pb-4">
    <div class="mobile-app-buttons hidden-xs">
      <a (click)="clickDownload('apple')" class="mr-3" href="https://itunes.apple.com/app/apple-store/id356866743?pt=309768&amp;ct=Driver%20Mobile%20Web%20Page&amp;mt=8" target="_blank"><img src="/assets/images/i_app_ios_n.png"/></a>
      <a (click)="clickDownload('google')" href="https://play.google.com/store/apps/details?id=com.coulombtech&amp;referrer=utm_source%3DDriver%2520Mobile%26utm_medium%3DWeb%2520Page" target="_blank"><img src="/assets/images/i_app_android_n.png"/></a>
    </div>
  </div>
  <div class="qr-download text-center pb-4">
    <p class="qr-download__label">{{ "Or scan to download the app" |T }}</p>
    <qrcode
      [qrdata]="qrDownloadUrl"
      [width]="160"
      [margin]="1"
      [errorCorrectionLevel]="'M'"
      [elementType]="'img'"
      alt="Scan to download the ChargePoint app">
    </qrcode>
  </div>
</ng-container>

<!-- Non-EU: keep the original "get a text to download the app" SMS flow. -->
<ng-container *ngIf="!isEu">
  <p> {{ "Now that you are all set, get a text to download the app." | T}}</p>
  <form>
    <cp-phone-w-country-simple #phoneWCountry [countryId]="countryId"
      [phoneNumber]="phoneNumber"></cp-phone-w-country-simple>
    <div *ngIf="serverErrorMessage" class="text-danger" role="alert">
      {{serverErrorMessage}}
    </div>
    <cp-signup-footer-controls [showBackButton]="false" (nextClicked)="onSubmitForm()" [nextButtonText]="'Send Text' | T"
      focusOnError="true"></cp-signup-footer-controls>
  </form>
</ng-container>

<a [href]="driverAccountURL">{{"View Account" | T}}</a>
